// src/auth/useIsAdmin.ts
import { useAccessFeatures } from './useAccessFeatures';

// True only for a signed-in admin. No identity yet (first mount, retrying,
// offline) reads as "not admin", so admin-only UI never flashes up early.
// Same role source as the route guard and the admin bypass in canUseFeature.
export function useIsAdmin(): boolean {
    return useAccessFeatures().role === 'admin';
}
